
/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    $.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-tickets-cost-of-works-of-client'),
            clientId = $datatable.data('client'),
        dataTables_buttons = [
	        {
		        extend: 'csv',
		        text: 'Export as CSV',
		        exportOptions: {
			        columns: [0, 1, 2]
		        },
	        },
	        {
		        extend: 'pdf',
		        text: 'Export as PDF',
		        exportOptions: {
			        columns: [0, 1, 2]
		        }
	        },
	        {
		        extend: 'print',
		        text: 'Print table',
		        exportOptions: {
			        columns: [0, 1, 2]
		        }
	        },
            {
                extend: 'colvis'
            }
        ];

    var table = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/tickets/clients/"+ clientId + '/cost-of-works',
            "method": 'POST',
            "data": function ( d ) {
	            d.status_id = $('select[name=status_id]').val();
	            d.property_type = $('input[name=property_type]:checked').val();
	            d.date_type = $('select[name=date_type]').val();
	            d.date = $('input[name=date]').val();
	            d.date_to = $('input[name=date_to]').val();
            }
        },
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "displayLength": 10,
        "order": [[ 1, "desc" ]],
        "columns": [
            {data: 'property_name', name: 'propertyName'},
	        {data: 'cost_of_works', name: 'costOfWorks', searchable: false},
	        {data: 'ticketsNumber', name: 'ticketsNumber', searchable: false},
	        {data: 'cost_of_works_number', name: 'costOfWorks', searchable: false, orderable: false, visible: false},
        ],
	    "footerCallback": function ( row, data, start, end, display ) {
		    var api = this.api(), data;

		    var intVal = function ( i ) {
		    	var number =  parseFloat(i);
			    return number ? number : 0;
		    };

		    // Total over this page
		    var pageTotalCostOfWorks  = api
		    .column( 3, { page: 'current'} )
		    .data()
		    .reduce( function (a, b) {
			    return intVal(a) + intVal(b);
			    // return a + b;
		    }, 0 );

		    var pageTotalTickets  = api
		    .column( 2, { page: 'current'} )
		    .data()
		    .reduce( function (a, b) {
			    return intVal(a) + intVal(b);
			    //   return a + b;
		    }, 0 );

		    // // Total over all pages
		    // totalCostOfWorks = api
		    // .column( 3, { page: 'all'} )
		    // .data()
		    // .reduce( function (a, b) {
			 //    return intVal(a) + intVal(b);
			 //    //return a + b;
		    // }, 0 );
		    //
		    // totalTickets = api
		    // .column(2, { page: 'all'})
		    // .data()
		    // .reduce( function (a, b) {
			 //    return intVal(a) + intVal(b);
			 //    //return a + b;
		    // }, 0 );

		    // Update footer
		    $( api.column( 1 ).footer() ).html(
				    // '£'+pageTotalCostOfWorks +' ( £'+ totalCostOfWorks +' total)'
		        '£'+ pageTotalCostOfWorks.toFixed(2)
		    );

		    $( api.column( 2 ).footer() ).html(
				    // pageTotalTickets +' ('+ totalTickets +' total)'
		        pageTotalTickets
		    );
	    }
    });

	$('#search-form').on('submit', function(e) {
		table.draw();
		e.preventDefault();
	});

});
